// extracted by mini-css-extract-plugin
module.exports = {"radioBox":"settings_radioBox_wAAIu","radio":"settings_radio_1vAq6"};